import { Translate } from 'react-redux-i18n'
import useSearchLocations from '../../../common/category/useSearchLocations'
import { Element } from '../../../common/html/element'
import { SelectCustom } from '../../../common/selectCustom'
import { handleLocationData } from './helper'

export const SelectCustomForm = ({
  title,
  containerStyle,
  hasCompany,
  chooseItem,
  activeItem,
}) => {
  const allCountry = useSearchLocations({ disableCallApi: true })
  const selectCustomData = handleLocationData(allCountry)

  return (
    <div style={{ ...containerStyle }}>
      <SelectCustom
        zIndex={13}
        activeItem={activeItem}
        data={selectCustomData}
        isI18n
        isNoWrap
        style={{ backgroundColor: '#FFFFFF', height: 28 }}
        styleDropdown={{ backgroundColor: '#FFFFFF' }}
        disabled={hasCompany}
        chooseItem={chooseItem}
      />

      <Element
        elementName="span"
        style={{
          backgroundColor: '#F3F3F3',
          padding: '2px 4px',
          left: 6,
          top: -14,
          color: '#3A414B',
        }}
        className="fw600 positionAbsolute"
      >
        <Translate value={title} />
      </Element>
    </div>
  )
}
